import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import messages from 'Workspace/messages';

const makeAvatarsFromCollaborators = (collaborators) => {
  const { teams = [], accounts = [] } = collaborators;

  return [
    ...teams.map((collaborator) => ({
      givenName: collaborator.team.name,
      role: collaborator.permissionLevel === 'OWNER' ? intl.formatMessage(messages.permissionOwner) : '',
    })),
    ...accounts.map((collaborator) => ({
      ...collaborator.account,
      role: collaborator.permissionLevel === 'OWNER' ? intl.formatMessage(messages.permissionOwner) : '',
    }))];
};

const getColor = (color, theme) => {
  switch (color) {
    case 'course':
    case 'unit':
      return theme['color.purpleLight'];
    case 'lesson':
      return theme['color.blueLight'];
    case 'project':
      return theme['color.primary'];
    default:
      return 'rgba(0,0,0,0.4)';
  }
};

const getIcon = (icon) => {
  switch (icon) {
    case 'course':
    case 'unit':
      return 'duotoneCourse';
    case 'lesson':
      return 'duotoneLesson';
    case 'eText':
      return 'duotoneEText';
    case 'project':
      return 'duotoneProjects';
    case 'import':
      return 'duotoneImport';
    case 'download':
      return 'download';
    case 'downloadTemplate':
      return 'downloadTemplate';
    case 'warningCircle':
      return 'warningCircle';
    case 'copyClipboard':
      return 'copyClipboard';
    case 'exclaimatoryIcon':
      return 'exclaimatoryIcon';
    default:
      return 'duotoneFile';
  }
};

export {
  makeAvatarsFromCollaborators,
  getColor,
  getIcon,
};
